import api from "./api";

class CfgAPI {

  async getFornecedores(headers) {

    const response = await api.get("/getFornecedores", { headers });
    return response;
  }

  async getCompradores(headers) {

    const response = await api.get("/getCompradores", { headers });
    return response;
  }

  async addFornecedor(headers, params) {
    const response = await api({
      method: 'post',
      url: '/add_fornecedor_ao_comprador',
      headers,
      data: params
    });
    return response;
  }

  async addComprador(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addComprador',
      headers,
      data: params
    });
    return response;
  }


  async delComprador(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delComprador',
      headers,
      data: params
    });
    return response;
  }


  //  funcoes de empresa

  async getEmpresas(headers) {

    const response = await api.get("/getEmpresas", { headers });
    return response;
  }

  async addEmpresa(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addEmpresa',
      headers,
      data: params
    });
    return response;
  }

  async delEmpresa(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delEmpresa',
      headers,
      data: params
    });
    return response;
  }

  // funcoes de grupos

  async getGrupos(headers, params = {}) {
    const response = await api.get("/getGrupos", { params, headers });
    return response;
  }

  async addGrupo(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addGrupo',
      headers,
      data: params
    });
    return response;
  }

  async delGrupo(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delGrupo',
      headers,
      data: params
    });
    return response;
  }

  //funcoes de grupo e filial

  async getGrupoFilial(headers) {

    const response = await api.get("/getGrupoFilial", { headers });
    return response;
  }

  async getFilial(headers) {
    const response = await api.get("/getFilial", { headers });
    return response;
  }

  async addGrupoFilial(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addGrupoFilial',
      headers,
      data: params
    });
    return response;
  }

  async delGrupoFilial(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delGrupoFilial',
      headers,
      data: params
    });
    return response;
  }

  async getSistemasIntegracao(headers) {

    const response = await api.get("/get_sistemas_integracao", { headers });
    return response;
  }

  async addSistemasIntegracao(headers, params) {
    const response = await api({
      method: 'post',
      url: '/add_sistemas_integracao',
      headers,
      data: params
    });
    return response;
  }

  async deleteSistemasIntegracao(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_sistemas_integracao',
      headers,
      data: params
    });
    return response;
  }

  async getSistemasAplicativos(headers) {

    const response = await api.get("/get_sistemas_aplicativos", { headers });
    return response;
  }

  async addSistemasAplicativos(headers, params) {
    const response = await api({
      method: 'post',
      url: '/add_sistemas_aplicativos',
      headers,
      data: params
    });
    return response;
  }

  async deleteSistemasAplicativos(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_sistemas_aplicativos',
      headers,
      data: params
    });
    return response;
  }

  async getAplicativosRelatorios(headers, params) {

    const response = await api.get("/get_aplicativos_relatorios", { headers, params });
    return response;
  }

  async getAtualizacoesSistema(headers) {

    const response = await api.get("/get_atualizacoes_sistema", { headers });
    return response;
  }

  async addAtualizacoesSistema(headers, params) {
    const response = await api({
      method: 'post',
      url: '/add_atualizacoes_sistema',
      headers,
      data: params
    });
    return response;
  }

  async getFiliaisRelatorio(headers, params) {
    const response = await api.get("/get_filiais_relatorios", { headers, params });
    return response;
  }

  async setFiliaisRelatorio(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_filial_relatorios',
      headers,
      data: params
    });
    return response;
  }

  async deleteFilialRelatorio(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_filial_relatorios',
      headers,
      data: params
    });
    return response;
  }

  async uploadLogo(headers, params) {
    const response = await api({
      method: 'post',
      url: '/upload-imagem-logo',
      headers,
      data: params
    });
    return response;
  }
}

export default new CfgAPI();
